module.exports = __webpack_public_path__ + "img/1011.e21f7bd0.png";